import React, { useState } from "react";
import { Button, Select, Input, Tooltip } from "antd";
import { Ticket, AF_END_ITERATION, AF_INITIATIV, AF_PLANNING_PRIORITY, AF_START_ITERATION, AF_TITLE, AF_AREA_PATH } from "../../services/Ticket";
import { CHILD_PRIORITY_OFFSET } from "../../Common/Constants";

interface AddNewProps {
  parent: Ticket;
  onSetRefresh: () => void;
  createTicket(project: string, ticketType: string, fields: Record<string, any>, parentUrl : string): Promise<any>
  onClose: () => void;
  teams: Array<{ team: string; project: string; ticketType?: string }>;
  selectedAreaPath?: string;
}

const AddNew: React.FC<AddNewProps> = (props) => {
  const [title, setTitle] = useState<string>("");
  // Only use parent project if it exists in teams list, otherwise default to empty
  const parentProjectInList = props.teams.some(team => team.project === props.parent.project);
  const [project, setProject] = useState<string>(parentProjectInList ? props.parent.project : "");

    return (
      <>
        <label>New titles</label>&nbsp;
        <Input
          placeholder="type in titles, separate with ';'"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: 300 }}
        />
        &nbsp;
        <Select
          style={{ width: 300 }}
          onChange={(value) => setProject(value)}
          onDeselect={() => setProject("")}
          value={project !== "" ? project : undefined}
          allowClear
          placeholder="Select a team"
        >
          {props.teams.map((item, index) => (
            <Select.Option key={String(index)} value={item.project}>
              {item.team}
            </Select.Option>
          ))}
        </Select>
        &nbsp;
        <Tooltip title={!title.trim() ? "Enter a title" : !project ? "Select a project" : ""}>
        <Button
          disabled={!title.trim() || !project}
          onClick={() => {
            const selectedTeam = props.teams.find(team => team.project === project);
            const _ticketType = selectedTeam?.ticketType || "Initiative";
            const titles = title.split(";").map((t) => t.trim()).filter((t) => t !== "");
        
            const promises = titles.map((t) => {
              const _fields: Record<string, any> = {
              ["/fields/" + AF_TITLE]: t,
              ["/fields/" + AF_START_ITERATION]: props.parent.startIteration,
              ["/fields/" + AF_END_ITERATION]: props.parent.endIteration,
              ["/fields/" + AF_INITIATIV]: props.parent.initiative,
              ["/fields/" + AF_PLANNING_PRIORITY]: props.parent.planningPri + CHILD_PRIORITY_OFFSET,
              };
              // If there is a selected area path filter, inherit it for new items
              try {
                const sel = props.selectedAreaPath;
                if (sel && sel !== "") {
                  const rootArea = (props.parent.area && props.parent.area.split('\\')[0]) || props.parent.project;
                  let areaValue = "";
                  if (sel === "__ROOT__" || sel === "/") {
                    areaValue = rootArea;
                  } else {
                    areaValue = `${rootArea}\\${sel}`;
                  }
                  if (areaValue) {
                    _fields["/fields/" + AF_AREA_PATH] = areaValue;
                  }
                }
              } catch (err) {
                console.warn('Failed to inherit selected area path for new ticket:', err);
              }
              return props.createTicket(project, _ticketType, _fields, props.parent.url);
            });

            Promise.all(promises).then(() => {
              props.onSetRefresh();
              props.onClose();
            }).catch((error) => {
              console.error('Failed to create one or more tickets:', error);
              props.onSetRefresh();
              props.onClose();
            });
          }}
        >
          Save
        </Button>
        </Tooltip>
      </>
    );
};

export default AddNew;
